import { createThirdwebClient, defineChain } from "thirdweb";
import { isTestnet } from "../../config/network";

// Define Nibiru EVM Chain (cataclysm-1 for mainnet, testnet-2 for testnet)
export const nibiruChain = defineChain({
  id: isTestnet()
    ? parseInt(process.env.REACT_APP_TESTNET_EVM_CHAIN_ID || "0x1AFF", 16)
    : parseInt(process.env.REACT_APP_NIBIRU_EVM_CHAIN_ID || "0x1AF4", 16),
  name: isTestnet() ? "Nibiru Testnet" : "Nibiru cataclysm-1",
  nativeCurrency: {
    name: "NIBI",
    symbol: "NIBI",
    decimals: 18,
  },
  rpc: isTestnet()
    ? (process.env.REACT_APP_TESTNET_EVM_RPC || "https://evm-rpc.testnet-2.nibiru.fi")
    : (process.env.REACT_APP_NIBIRU_EVM_RPC || "https://evm-rpc.nibiru.fi"),
  blockExplorers: [
    {
      name: "Nibiru Explorer",
      url: isTestnet()
        ? (process.env.REACT_APP_TESTNET_BLOCK_EXPLORER || "https://testnet.nibiscan.io")
        : "https://nibiscan.io",
    },
  ],
});

export const thiredWebClient = createThirdwebClient({
  clientId: process.env.REACT_APP_THIRDWEB_CLIENT_ID || "92ed4af549afb692bed23bba434a0d25",
});

export const truncateWalletAddress = (address, forward = 5, backward = 4) => {
  if (address)
    return (
      address.toString().substring(0, forward) +
      "..." +
      address.toString().substring(address.toString().length - backward)
    );
};

export const getTime = (date) => {
  try {
    let dateObj;
    
    // Handle different input types
    if (!date) {
      dateObj = new Date();
    } else if (typeof date === 'string') {
      dateObj = new Date(date);
    } else if (date instanceof Date) {
      dateObj = date;
    } else {
      // Handle timestamp
      dateObj = new Date(date);
    }
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      console.error("Invalid date:", date);
      return new Date().toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit', 
        hour12: true 
      });
    }
    
    // Use local time formatting
    return dateObj.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit', 
      hour12: true 
    });
  } catch (error) {
    console.error("Error formatting time:", error);
    return new Date().toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit', 
      hour12: true 
    });
  }
};

export const getDay = (date) => {
  try {
    let dateObj;
    
    // Handle different input types
    if (!date) {
      dateObj = new Date();
    } else if (typeof date === 'string') {
      dateObj = new Date(date);
    } else if (date instanceof Date) {
      dateObj = date;
    } else {
      // Handle timestamp
      dateObj = new Date(date);
    }
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      console.error("Invalid date:", date);
      return new Date().toLocaleDateString('en-US', { 
        month: 'short', 
        day: '2-digit' 
      });
    }
    
    const currentTime = new Date();
    
    // Check if it's today
    if (
      currentTime.getFullYear() === dateObj.getFullYear() &&
      currentTime.getMonth() === dateObj.getMonth() &&
      currentTime.getDate() === dateObj.getDate()
    ) {
      return "Today";
    }
    
    // Check if it's yesterday
    const yesterday = new Date(currentTime);
    yesterday.setDate(yesterday.getDate() - 1);
    
    if (
      yesterday.getFullYear() === dateObj.getFullYear() &&
      yesterday.getMonth() === dateObj.getMonth() &&
      yesterday.getDate() === dateObj.getDate()
    ) {
      return "Yesterday";
    }
    
    // Return formatted date
    return dateObj.toLocaleDateString('en-US', { 
      month: 'short', 
      day: '2-digit' 
    });
  } catch (error) {
    console.error("Error formatting day:", error);
    return new Date().toLocaleDateString('en-US', { 
      month: 'short', 
      day: '2-digit' 
    });
  }
};